import * as AppUtils from '../Utils/AppUtils';
import appConstants from "../appConstants";

var userSessionData = AppUtils.getSessionStorageData(appConstants.USER_SESSION_KEY);

var SAML_AUTH_SERVER_URL = window.appConfig.SAML_AUTH_SERVER_URL;
var SSO_URL = window.appConfig.SSO_URL;
export default
{
	//Headers
	headers:
	(
		{
			"Content-Type": "application/json",
			"Authorization": userSessionData ? userSessionData.token : ""
		}
	),

	SUCCESS_STATUS_TEXT: "SUCCESS",
	FAILURE_STATUS_TEXT: "FAILURE",
	//STATUS CODE
	SUCCESS_STATUS_CODE: 200,
	FORBIDDEN_STATUS_CODE: 403,
	SAML_ACCOUNT_NOT_FOUND_ERR_CODE: 601,
	SAML_INVALID_ACCOUNT_STATUS_CODE: 604,

	//SAML AUTHENTICATION API PARAMS AND VALUES
	EMAIL_PARAM: "email",
	DOMAIN_PARAM: "domain",
	APPLICATION_PARAM: "application",
	MYVIE_DASHBOARD: "myvie-dashboard",
	RETURN_URL_PARAM: "return-url",
	SAML_TYPE_PARAM: "type",
	SAML_TYPE_VALUE: "SAML",
	SAML_ERROR_PARAM: "error",

	//Others
	ASSET_LIST_LIMIT: 0,
	CUSTOMER_LIST_LIMIT:0,
	USER_LIST_LIMIT: 0,
	SENSOR_LIST_LIMIT: 0,

	profilepicURL: "/profilepic/default.jpg",

	//URL  -  //login
	changePasswordURL : "/users/changePassword",
	forgotPasswordURL : "/users/forgotPassword",
	loginAuthenticationURL: "/users/loginAuthentication",
	loginUserDetailsURL: "/sso/userDetails/",
	samlTokenAuthenticationURL: SAML_AUTH_SERVER_URL + "/login",
	tokenAuthenticationURL: "/users/authentication",
	updateUserLicenseAgreementStatus: "/users/updateUserLicenseAgreementStatus",
	ssoRedirectAuthURL: SSO_URL + "/auth-url/" + appConstants.LOGIN_TYPE_VIE_INTERNAL + "/" + window.appConfig.SSO_APP_NAME,
	getTenantListURL: SSO_URL + "/tenants?applicationName=" + window.appConfig.SSO_APP_NAME,
	validateTenantId: SSO_URL + "/validate",
	//Asset
	addSuperAssetCommentURL: "/superasset/addSuperAssetComment",
	assetCountURL: "/assets/count/customer/",
	assetConditionSummaryInfoURL: "/assets/getPrognosisSummaryInfo",
	assetDetailsURL: "/assets/fetchAssetDetails/",
	assetGraphDataURL: "/motereport/fetchGraphData/",
	addAssetCommentURL: "/assets/addAssetComment",
	deleteAssetImageURL: "/assets/image/delete",
	fetchAssetCommentsURL: "/assets/fetchAssetComments",
	fetchAssetImagesURL: "/assets/fetchAssetImages",
	fetchPerformanceGraphDataURL: "/motereport/fetchPerformanceGraphData/",
	fetchSuperAssetImagesURL: "/superasset/fetchSuperAssetImages",
	deleteSuperAssetImageURL: "/superasset/image/delete",
	assetHistoryURL: "/events/fetchAssetHistoryFeedList",
	assetListURL: "/assets/fetchAssetList",
	advancedAnalysisDateTimeListURL: "/motereport/fetchAdvancedAnalysisDateTimeList/",
	advancedAnalysisInfoURL: "/motereport/fetchAdvancedAnalysisInfo/",
	faultEnumURL: "/fault/enums",
	metricsURL: "/motereport/getMetricsInfo",
	quickFeedbackURL: "/feedback/quick/true/true/true",
	userEventQuickFeedbackURL: "/feedback/notification/true/true/true",
	reportDownloadURL: "/motereport/measurement-data-download/",
	superAssetListURL: "/assets/fetchSuperAssetList",
	superAssetDetailsURL: "/superasset/details",
	superAssetCommentsURL: "/superasset/fetchSuperAssetComments",
	updateMoteStateURL: "/motereport/changeMoteState/",
	updateCustAssetTagURL: "/assets/updateCustAssetTag",
	updateAlternateIdURL: "/superasset/alternate-id",

	//Customer
	customerListURL: "/customers/fetchCustomerList",

	//Feed
	addUserFeedURL: "/events/create",
	addFeedCommentURL: "/events/Eventcomments/create/",
	feedFollowOrUnfollowURL: "/events/follow/update",
	feedListURL: "/events/fetchFeedList",
	refreshFeedListURL: "/events/refreshFeedList",
	ticketCommentsURL: "/events/fetchTicketComments",
	feedCommentURL: "/events/fetchEventComments",

	//Sensor
	exportSensorListURL: "/assets/sensor/export",
	replaceSensorURL: "/opamotes/replaceAssetSensor",
	addSensorURL: "/opamotes/addSensor",
	getProgramIdURL: "/opamotes/programId",
	sensorListURL: "/assets/fetchSensorList",
	sensorHistoryURL: "/opamotes/fetchSensorHistory/",
	updateSensorUnresponsiveReasonURL: "/assets/updateSensorUnresponsiveReason",
	sensorUnresponsiveReasonListURL: "/assets/fetchSensorUnresponsiveReasonList",
	fetchUnattachedSensorListURL: "/opamotes/fetchUnattachedSensorList",
	updateSensorInfoURL: "/opamotes/updateSensorDirection",
	detachSensorURL: "/opamotes/detachSensor",
	
	//Ticket
	addTicketCommentURL: "/events/Ticketcomments/create",
	assignUserToTicketURL: "/tickets/update/",
	addFeedbackWithFilesURL: "/feedback/add",
	createTicketByAssetFeedOrUserFeedURL: "/tickets/create/",
	feedbackHistoryURL: "/feedback/history/",
	ticketCloseOrReopenURL: "/tickets/close/",
	ticketDetailsURL: "/tickets/fetchTicketDetails/",
	
	//User
	userDetailsURL: "/users/fetchUserDetails",
	userListURL: "/users/fetchUserList",

	rotateImage: "/assets/image/rotate",

	// Feedback tags
	feedbackFilesByTicketIdURL: "/events/feedback/",
	fetchFeedbackTagsURL: "/feedback/tags",
	downloadFeedbackFilesURL: "/feedback/files/download",

	verifyFeedbackTokenURL: "/users/verify-feedback-token",
	fetchFeedbackAssetDetailsURL: "/feedback/asset-details",

	//Oil Report
	oilTestReportFilesURL: "report/oil-test/files",
	oilTestReportUploadURL: "report/oil-test/upload",

}
